import { type EventEmitter, type FunctionalComponent, h } from '@stencil/core';
import { DUMMY_URL } from './offsite-dummy-banner-config';

export interface OffsitesDummyEventsLayer {
  eventEmitter: EventEmitter;
  tabName: string;
  widgetName: string;
  term: string;
  brand: string;
  country: string;
  language: string;
}

export const OffsitesDummyEventsLayer: FunctionalComponent<
  OffsitesDummyEventsLayer
> = (props, children) => {
    const invokeEvent = (e) => {
        const elementsWithAreas = [
          ...e.composedPath().filter((el) => el.dataset?.widgetArea),
        ][0];
        const widgetArea = elementsWithAreas?.dataset?.widgetArea;
        const widgetLink = DUMMY_URL[props.brand]
          ?.replace('$CC', props.country)
          .replace('$LL', props.language);
        const label = [
          'tabName:' + props.tabName,
          'clickedArea:' + widgetArea,
        ].join('###');

        return {
          location: 'SRP',
          ctaName: 'Create your account',
          ctaLink: widgetLink,
          category: 'mySchneider',
          keyword: props.term,
          label: label,
        };
    };

    return (
      <host
        onMouseDown={(e) => {
            props.eventEmitter.emit({ ...invokeEvent(e) });
        }}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
              props.eventEmitter.emit({ ...invokeEvent(e) });
            }
        }}
      >
        {children}
      </host>
    );
};
